import styled, { css } from 'styled-components';
import { Form as FormikForm } from 'formik';
import { Wrapper as FloatButtonStyle } from 'components/FloatButtonBar/style';
import { Container } from 'components/GridSystem';

export const Wrapper = styled.section`
  ${({ theme }) => css`
    background-color: ${theme.colors.globalWhite100};
    min-height: 100%;

    ${FloatButtonStyle} {
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 9;
    }

    @media (max-width: 576px) {
      min-height: 100%;
    }
  `}
`;
export const Main = styled.main``;

export const Form = styled(FormikForm)`
  padding-top: 48px;

  display: flex;
  flex-direction: column;

  width: 100%;

  gap: 24px;
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    font-weight: 600;
    font-size: 2rem;
    line-height: 2.6rem;

    margin-bottom: 20px;

    color: ${theme.colors.purple100};
  `}
`;

export const PaymentInformationContainer = styled(Container)`
  ${({ theme }) => css`
    text-align: left;

    padding-top: 20px;
    padding-bottom: 20px;

    margin-bottom: 24px;

    border-bottom: 1px solid ${theme.colors.primary10};
  `}
`;

export const PaymentInformationContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 40px;
`;

export const Info = styled.div`
  text-align: left;
`;

export const InfoTitle = styled.p`
  ${({ theme }) => css`
    font-weight: 500;
    font-size: 1.6rem;
    line-height: 2rem;

    margin-bottom: 4px;

    color: ${theme.colors.neutralSilver60};
  `};
`;

export const InfoSubtitle = styled.p`
  ${({ theme }) => css`
    font-weight: 400;
    font-size: 1.4rem;
    line-height: 1.6rem;

    color: ${theme.colors.neutralSilver60};
  `};
`;
